module.exports = __webpack_public_path__ + "img/event_invite.af90bb21.png";